export enum ItemCategory {
    Microcontroller = 'Microcontroller',
    Component = 'Component',
    Hardware = 'Hardware',
}
